
import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import {  
  ApiManager,
  sessionService,
  LoggerUtility
} from '../components/ComponentsLibrary';


//Authorization code from here.
const userSession = {
    orgId: 1,
    siteId: 1000,
    roleId: 1,
    siteRoleId: 1,
    statusId: 2,
};


// Extract the values other than the last number from a tilde-separated string
// Example: 1000~300~20~1 Returns 1000~300~20
// Example: 300~20~1 Returns 300~20
const extractValuesExceptLastNumber = (column) => {
    const values = column.split('~');

    // If there's only one value or no values, return an empty string or handle accordingly
    if (values.length <= 1) {
        return { ruleValue: '', permissionValue: 1 }; // Default: 1 is provide write access
    }

    const permission = values.pop(); // Remove the last element
    const rule = values.join('~'); // Extract the value other than the last number from a tilde-separated string

    return { ruleValue: rule, permissionValue: permission };
};

// Function to check if access exists in a source data and return the last number from the matching item
// Example: sourceData: 1000~300~20~1, 2000~100~30~2, comparisonValue: 2000~100~30 Returns { true, 2 }
const checkAccessAvailableInSource = (sourceData, comparisonValue) => {
    try {
        // Split the source string into an array of items
        // const sourceItems = sourceData.split(", ");

        // Find the matching item
        const matchingItem = sourceData.find(item => {
            // Split the item by "~"
            const parts = item.split("~");
            // Remove the last number and join the remaining parts with "~"
            const itemPart = parts.slice(0, -1).join("~");
            // Compare with comparisonValue
            return itemPart === comparisonValue;
        });

        // If a matching item is found, return the last number
        if (matchingItem) {
            const lastNumber = matchingItem.split("~").pop(); // Get the last number
            return { accessAvailable: true, permissionValue: lastNumber }; // Return both existence and the last number
        }

        // If no matching item is found, return false
        return { accessAvailable: false, permissionValue: 1 }; // Default: 1 - provide write access as default value
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "checkAccessAvailableInSource", {});
    }
};

const assignPermissionToControl = (permissionValue) => {
    try {
        const accessKeys = { write: '1', read: '2', hide: '3' };
        const initialAccess = { write: false, read: false, hide: false };

        return Object.entries(initialAccess).reduce((permission, [key]) => {
            permission[key] = accessKeys[key] === permissionValue;
            return permission;
        }, {});
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "assignPermissionToControl", {});
    }
};

const checkAccess = (loginUserInfo, controlSecurity) => {
    try {
        const defaultAccess = { write: true, read: false, hide: false };
        const accessMapping = [
            // { type: 'StatusAccess', value: String(session.statusId) },
            { type: 'roleAccess', value: String(loginUserInfo ? loginUserInfo.roleID : 0) },
            // { type: 'RoleStatusAccess', value: `${session.roleId}~${session.statusId}` },
            // { type: 'SiteStatusAccess', value: `${session.siteId}~${session.statusId}` },
            // { type: 'SiteRoleStatusAccess', value: `${session.siteId}~${session.roleId}~${session.statusId}` },
            { type: 'siteRoleAccess', value: `${loginUserInfo ? loginUserInfo.stateID : 0}~${loginUserInfo ? loginUserInfo.roleID : 0}` },
            { type: 'siteAccess', value: String(loginUserInfo ? loginUserInfo.stateID : 0) },
            { type: 'orgAccess', value: String(loginUserInfo ? loginUserInfo.orgClientID : 0) },
        ];

        for (let access of accessMapping) {
            if (controlSecurity[access.type] !== '') {
                const accessRules = controlSecurity[access.type]?.split(',') || [];
                const { accessAvailable, permissionValue } = checkAccessAvailableInSource(accessRules, access.value);
                if (accessAvailable) {
                    const actualAccess = assignPermissionToControl(permissionValue);
                    return actualAccess;
                }
            }
        }

        return defaultAccess;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "checkAccess", {});
    }
};


const checkAccess02 = (loginUserInfo, controlSecurity, accessType) => {
    try {

        const accessMapping = [
            // { type: 'StatusAccess', value: String(session.statusId) },
            { type: 'roleAccess', value: String(loginUserInfo ? loginUserInfo.roleID : 0) },
            // { type: 'RoleStatusAccess', value: `${session.roleId}~${session.statusId}` },
            // { type: 'SiteStatusAccess', value: `${session.siteId}~${session.statusId}` },
            // { type: 'SiteRoleStatusAccess', value: `${session.siteId}~${session.roleId}~${session.statusId}` },
            { type: 'siteRoleAccess', value: `${loginUserInfo ? loginUserInfo.stateID : 0}~${loginUserInfo ? loginUserInfo.roleID : 0}` },
            { type: 'siteAccess', value: String(loginUserInfo ? loginUserInfo.stateID : 0) },
            { type: 'orgAccess', value: String(loginUserInfo ? loginUserInfo.orgClientID : 0) },
        ];

        for (let access of accessMapping) {
            const accessRules = controlSecurity[access.type]?.split(',') || [];

            for (let rule of accessRules) {
                const parts = rule.split('~');
                let permission;

                if (parts.length === access.value.split('~').length + 1) {
                    permission = parts.pop();

                    if (parts.join('~') === access.value && parseInt(permission) === accessType) {
                        return true;
                    }
                }
            }
        }
        if (accessType === 1) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "checkAccess", {});
    }
};

const checkAccess_ByEvent = (controlSecurity, session, accessType) => {
    try {
        const accessMapping = [
            { type: 'Status_Access', value: String(session.statusId) },
            { type: 'Role_Access', value: String(session.roleId) },
            { type: 'RoleStatus_Access', value: `${session.roleId}~${session.statusId}` },
            { type: 'SiteStatus_Access', value: `${session.siteId}~${session.statusId}` },
            { type: 'SiteRoleStatus_Access', value: `${session.siteId}~${session.roleId}~${session.statusId}` },
            { type: 'SiteRole_Access', value: `${session.siteId}~${session.roleId}` },
            { type: 'Site_Access', value: String(session.siteId) },
            { type: 'Org_Access', value: String(session.orgId) },
        ];

        for (let access of accessMapping) {
            const accessRules = controlSecurity[access.type]?.split(',') || [];

            for (let rule of accessRules) {
                const parts = rule.split('~');
                let permission;

                if (parts.length === access.value.split('~').length + 1) {
                    permission = parts.pop();

                    if (parts.join('~') === access.value && parseInt(permission) === accessType) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "checkAccess_ByEvent", {});
    }
};

const DeterminePermissions = (controls) => {
    try {
        const loginUserInfo = sessionService.getUser();
        let permissions = {};
        controls.forEach((control) => {
            const controlSecurity = controls.find((cs) => cs.controlSecurityID === control.controlSecurityID);
            if (controlSecurity) {
                permissions[control.controlName] = checkAccess(loginUserInfo, controlSecurity);

                /* permissions[control.controlName] =
                {
                    read: checkAccess(loginUserInfo, controlSecurity, 2),
                    write: checkAccess(loginUserInfo, controlSecurity, 1),
                    hide: checkAccess(loginUserInfo, controlSecurity, 3),
                }; */
            }
            else {

            }
        });

        return permissions;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "DeterminePermissions", {});
    }
};


const DeterminePermissions2 = (formControls) => {
    try {

        let permissions = {};
        
        // Process each form control
        formControls.forEach((control) => {
            // Base permissions on formControlDisplay
            if (control.formControlDisplay === true) {
                // Control should be visible and accessible
                permissions[control.controlName] = {
                    read: false,
                    write: true,
                    hide: false
                };
            } else if (control.formControlDisplay === false) {
                // Control should be hidden or read-only
                permissions[control.controlName] = {
                    read: false,
                    write: false,
                    hide: true
                };
            } else {
                // Default fallback for null/undefined formControlDisplay
                permissions[control.controlName] = {
                    read: false,
                    write: false,
                    hide: false
                };
            }

        });

        return permissions;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "DeterminePermissions2", {});
    }
};

const DeterminePermissionsByEvent = (controls_ByEvent) => {
    try {
        const session = userSession;
        let permissions = {};

        controls_ByEvent.forEach((control) => {
            const controlSecurity_ByEvent = controls_ByEvent.find((cs) => cs.id === control.id);
            if (controlSecurity_ByEvent) {
                permissions[control.Destination_Control_Name] = {
                    read: checkAccess_ByEvent(controlSecurity_ByEvent, session, 2),
                    write: checkAccess_ByEvent(controlSecurity_ByEvent, session, 1),
                    hide: checkAccess_ByEvent(controlSecurity_ByEvent, session, 3),
                };
                
            }
            else {
                // console.warn(`No control security found for control ID ${control.id}`);
            }
        });

        return permissions;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "DeterminePermissionsByEvent", {});
    }
};

const FetchControls = async (apiUrl) => {
    try {
        const controlSecurityAPIurl = apiUrl;
        const controlSecurityListApiData = await ApiManager.GetDataFromAPI(controlSecurityAPIurl, {}, 123456);
        return controlSecurityListApiData;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "FetchControls", {});
    }
};

const FetchControlsByEvent = async (apiUrl) => {
    try {
        const controlAccessAPIurl = apiUrl;
        const controlAccessApiData = await ApiManager.GetDataFromAPI(controlAccessAPIurl, {}, 234567);
        return controlAccessApiData;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "FetchControlsByEvent", {});
    }
};

// 🔍 ADD: Helper function to determine first available page
const getFirstAvailablePage = (permissions) => {
    // Define page priority order with their required permissions
    const pagePermissionMap = [
        { path: '/newdocument', permission: 'btnNewDocument' },
        { path: '/nextworkitem', permission: 'btnNext' },
        { path: '/newworkitem', permission: 'btnNewWorkflow' },
        { path: '/queueworkflow', permission: 'btnQueueWorkflow' },
        { path: '/documentsearch', permission: 'btnViewDocument' },
        { path: '/completed', permission: 'btnCompletedWorkflow' },
        { path: '/caseView', permission: 'btnViewCase' },
        { path: '/errorFallbackPage', permission: null }, // Always available fallback
        { path: '/myytrac', permission: 'btnMyYTracSystemInfo' },
    ];

    // Find first page user has permission for
    for (const page of pagePermissionMap) {
        if (!page.permission) {
            // No permission required (fallback page)
            return page.path;
        }
        
        // Check if user has permission (not hidden)
        if (!(permissions[page.permission]?.hide ?? false)) {
            console.log(`🔍 User has access to ${page.path} via ${page.permission}`);
            return page.path;
        } else {
            console.log(`🔍 User denied access to ${page.path} - ${page.permission} is hidden`);
        }
    }

    // Ultimate fallback
    return '/errorFallbackPage';
};

//aa--------------------------------------------------------------------


export {
    DeterminePermissions,
    DeterminePermissions2,
    DeterminePermissionsByEvent,
    FetchControls,
    FetchControlsByEvent,
    getFirstAvailablePage
};